// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"8ee428f8","151":"fdcd3336","453":"cf573149","614":"af0cafa1"}[chunkId] + ".chunk.js";
};